import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

type PageTopBarContextType = {
  stringTitle?: string;
  setStringTitle: (title: string) => void;
  nodeTitle: ReactNode;
  setNodeTitle: (node: ReactNode) => void;
};

const PageTopBarContext = createContext<PageTopBarContextType>({
  stringTitle: undefined,
  setStringTitle: () => {},
  nodeTitle: undefined,
  setNodeTitle: () => {},
});

interface PageTopBarProviderProps {
  initialStringTitle: string;
  initialNodeTitle?: ReactNode;
  children: ReactNode;
}

export const PageTopBarProvider = ({ initialStringTitle, initialNodeTitle, children }: PageTopBarProviderProps) => {
  const [stringTitle, setStringTitle] = useState<string>(initialStringTitle);
  const [nodeTitle, setNodeTitle] = useState<ReactNode>(initialNodeTitle);

  const contextValue = {
    stringTitle,
    setStringTitle,

    nodeTitle,
    setNodeTitle,
  };

  return <PageTopBarContext.Provider value={contextValue}>{children}</PageTopBarContext.Provider>;
};

export const usePageTopBar = () => {
  return useContext(PageTopBarContext);
};
